import { Component, Input } from '@angular/core';
import { ITS_JUST_ANGULAR } from '@angular/core/src/r3_symbols';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from '@app/_services/course.service';

@Component({ selector: 'meditation', templateUrl: 'meditation.component.html' })
export class MeditationComponent {

    currentIndex: number;
    courseId: any;

    steps = [
        { stepIndex: 0, isComplete: false, value: "" },
        { stepIndex: 1, isComplete: false, value: "" },
        { stepIndex: 2, isComplete: false, value: "" },
        { stepIndex: 3, isComplete: false, value: "" },
        { stepIndex: 4, isComplete: false, value: "" },
        { stepIndex: 5, isComplete: false, value: "" },
        { stepIndex: 6, isComplete: false, value: "" },
    ];

    constructor(private courseService: CourseService, private route: ActivatedRoute, private router: Router) {

    }

    get allAnswersDone() {
        return this.steps.filter(x => x.stepIndex < 6 && x.isComplete == false).length == 0;
    }

    ngOnInit() {
        this.currentIndex = this.steps[0].stepIndex;
        this.route.paramMap.subscribe(params => {
            this.courseId = params.get('id');
        });


        setTimeout(x => { this.moveToNextStep() }, 29000);

    }

    moveToNextStep() {
        this.steps[this.currentIndex].isComplete = true;
        this.currentIndex = this.steps[this.currentIndex + 1].stepIndex;
    }

    begin() {
        this.courseService.addPreCourseEvent(this.courseId, "meditation").subscribe( (response:any) => {
            var sectionId = response.firstSectionId;
            this.router.navigate(['/course-section', sectionId]);
        });
    }

    resize(element) {
        element.target.style.height = element.target.scrollHeight + "px";
    }

    change(element, index) {
        this.resize(element);
        this.currentIndex = index;
        let answer = element.target.value;
        if (answer.trim() != '')
        {
            this.steps[this.currentIndex].value = element.target.value;
            this.moveToNextStep();
        } else {
            this.steps[this.currentIndex].isComplete = false;
        }
    }

}